import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BodyEncodingInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.body && request.method !== 'GET' && request.method !== 'DELETE') {
      const body = request.body;

      if (this.isEncodableBody(body)) {
        const encodedBody = this.encodeValue(body);
        request = request.clone({ body: encodedBody });
      } else if (typeof body === 'string') {
        request = request.clone({ body: this.encodeStringIfNeeded(body) });
      }
    }

    return next.handle(request);
  }

  private isEncodableBody(value: unknown): value is Record<string, unknown> | unknown[] {
    return value !== null
      && typeof value === 'object'
      && !(value instanceof FormData)
      && !(value instanceof Blob)
      && !(value instanceof ArrayBuffer);
  }

  private encodeValue(value: unknown): unknown {
    if (typeof value === 'string') {
      return this.encodeStringIfNeeded(value);
    }

    if (Array.isArray(value)) {
      return value.map(item => this.encodeValue(item));
    }

    if (this.isEncodableBody(value)) {
      const encoded: Record<string, unknown> = {};
      Object.keys(value).forEach(key => {
        encoded[key] = this.encodeValue((value as Record<string, unknown>)[key]);
      });
      return encoded;
    }

    return value;
  }

  private encodeStringIfNeeded(value: string): string {
    if (this.hasSuspiciousSequence(value)) {
      return encodeURIComponent(value);
    }
    return value;
  }

  private hasSuspiciousSequence(value: string): boolean {
    return /prompt\s*\(/i.test(value);
  }
}
